import { render, staticRenderFns } from "./bbwzTable.vue?vue&type=template&id=55e41fb2&scoped=true"
import script from "./bbwzTable.vue?vue&type=script&lang=ts"
export * from "./bbwzTable.vue?vue&type=script&lang=ts"
import style0 from "./bbwzTable.vue?vue&type=style&index=0&id=55e41fb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e41fb2",
  null
  
)

export default component.exports